export default __webpack_public_path__ + "static/media/left.f2f246be.png";